module.exports = __webpack_public_path__ + "img/34.31870539.png";